import dayjs from "dayjs";

function diasBase360(fechaInicio, fechaFin) {
  let d1 = fechaInicio.date();
  let m1 = fechaInicio.month() + 1;
  let a1 = fechaInicio.year();

  let d2 = fechaFin.date();
  let m2 = fechaFin.month() + 1;
  let a2 = fechaFin.year();

  if (d1 === 31) d1 = 30;
  if (d2 === 31 && d1 === 30) d2 = 30;

  return (a2 - a1) * 360 + (m2 - m1) * 30 + (d2 - d1);
}

export function calcularDeudaRestante(
  nextPayment,
  fechaCurrent,
  currentPayment,
  tasa
) {
  const lastPaymentDate = dayjs(currentPayment?.fechaPago, "DD/MM/YYYY").format(
    "YYYY-MM-DD"
  );

  const fechaHoy = dayjs(fechaCurrent); // fecha actual
  const fechaAnterior = dayjs(lastPaymentDate, "YYYY-MM-DD"); // parsea correctamente
  const fechaNextPayment = dayjs(nextPayment.fechaPago, "DD/MM/YYYY");

  const diasDesdeUltimoPago = diasBase360(fechaAnterior, fechaHoy);

  if (
    !fechaHoy.isValid() ||
    !fechaNextPayment.isValid() ||
    !fechaAnterior.isValid()
  ) {
    return Number.NaN;
  }

  const tasaInteresDiaria = Number(tasa) / 100 / 360;

  const saldoDeuda = nextPayment.valorPrestamo;

  const interesAcumulado = saldoDeuda * tasaInteresDiaria * diasDesdeUltimoPago;
  const deudaRestante = saldoDeuda + interesAcumulado;

  return deudaRestante;
}
